export class ValidationResult {

  get hasErrors(): boolean {
    return this.errors.length > 0;
  }

  get getErrors(): Error[] {
    return this.errors;
  }

  private errors: Error[] = [];
  private validators: Validator[] = [];

  constructor(validators: Validator[]) {
    this.validators = validators;
  }

  public init(): void {
    this.errors = [];
  }

  public validateList(targets: any[], targetPredicate: (value: any) => boolean = defaultTargetPredicate) {
    this.init();
    targets.forEach((target, index) => {
      if (targetPredicate(target)) this.validate(target, index);
    });
  }

  public validate(target: any, index: number = 0) {
    for (const validator of this.validators) {
      const key = validator.name;
      const value = this._getValue(target, key);
      for (const constraint of validator.constraints) {
        if (!constraint.method(value)) {
          if (this._hasError(key, index, constraint.method.name)) {
            continue;
          }
          this.errors.push({index, name: key, message: constraint.message, constraint: constraint.method.name});
        } else {
          this._removeError(key, index, constraint.method.name);
        }
      }
    }
  }

  public hasError(name: string, index: number = 0): boolean {
    return this.errors.some((error) => (error.name === name && error.index === index));
  }

  public getMessages(viewIndex: boolean = false): string[] {
    const errorMessages = this.errors.map((error) => error.message);
    return Array.from(new Set(errorMessages));
  }

  private _hasError(name: string, index: number = 0, constraint: string): boolean {
    return this.errors.some((error) =>
      (error.name === name && error.constraint === constraint && error.index === index));
  }

  private _removeError(name: string, index: number = 0, constraint: string): boolean {
    return this.errors.some((error, i) => {
      if (error.name === name && error.constraint === constraint && error.index === index) {
        this.errors.splice(i, 1);
      }
    });
  }

  private _getValue(target: any, key: string): any {
    const properties: string[] = Array.isArray(key) ? [key] : key.split('.');
    return properties.reduce((prev, curr) => prev && prev[curr], target);
  }
}

function defaultTargetPredicate(target: any) {
  return true;
}

export interface Validator {
  name: string;
  constraints: Constraint[];
}

export interface Constraint {
  method: (value: any) => boolean;
  message: string;
}

export interface Error {
  index: number;
  name: string;
  message: string;
  constraint: string;
}
